/* nt-email — compone los correos que el HTML lleva ocultos (ver snippets/nt-email.liquid).
   Dos formas: <a class="nt-em" data-m="…"> (dirección invertida + base64, la genera Liquid) y el
   marcador de texto «[[correo:usuario|dominio]]» en el DOM (políticas de /policies/*, que pinta
   Shopify sin pasar por nuestras secciones). Se carga como asset al final de layout/theme.liquid.
   Expone window.ntEmail.resolve(nodo) para texto que otro script inyecte después de cargar la
   página (p. ej. el mensaje de error del formulario de empleo, que cita cv@). */
(function () {
  var dec = new TextDecoder();
  var re = /\[\[correo:([^\]|]+)\|([^\]|]+)(?:\|([^\]]*))?\]\]/;
  function resolve(root) {
    root = root || document.body;
    root.querySelectorAll('a.nt-em[data-m]').forEach(function (a) {
      try {
        var b = atob(a.getAttribute('data-m')), u = new Uint8Array(b.length);
        for (var i = 0; i < b.length; i++) u[i] = b.charCodeAt(i);
        var m = dec.decode(u).split('').reverse().join('');
        a.href = 'mailto:' + m;
        if (!a.hasAttribute('data-l')) a.textContent = m.split('?')[0];
        a.removeAttribute('data-m');
      } catch (e) {}
    });
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), t, list = [];
    while ((t = w.nextNode())) if (t.nodeValue.indexOf('[[correo:') !== -1) list.push(t);
    list.forEach(function (n) {
      var m, s = n.nodeValue, frag = document.createDocumentFragment();
      while ((m = re.exec(s))) {
        frag.appendChild(document.createTextNode(s.slice(0, m.index)));
        var a = document.createElement('a'), addr = m[1] + '@' + m[2];
        a.className = 'nt-em'; a.href = 'mailto:' + addr; a.textContent = m[3] || addr;
        frag.appendChild(a); s = s.slice(m.index + m[0].length);
      }
      frag.appendChild(document.createTextNode(s));
      n.parentNode.replaceChild(frag, n);
    });
  }
  window.ntEmail = { resolve: resolve };
  resolve(document.body);
})();
